/**
 * 表单字段 ACL 解析：优先 fullkey，其次 key / id / 路径后缀
 * 0 可见可编辑；1 只读；2 隐藏
 *
 * 注意：不依赖 flow-acl，避免与表单组件循环引用导致 mixin methods 丢失
 */
function unpackAcl(raw) {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return {};
  // 打包结构 { __v, acl, binds }
  if (raw.__v === 2 || (raw.binds && typeof raw.binds === 'object') ||
    (raw.acl && typeof raw.acl === 'object' && !Array.isArray(raw.acl) &&
      (Object.prototype.hasOwnProperty.call(raw, 'acl') ||
        Object.prototype.hasOwnProperty.call(raw, 'binds') ||
        Object.prototype.hasOwnProperty.call(raw, '__v')))) {
    const src = raw.acl && typeof raw.acl === 'object' ? raw.acl : {};
    const out = {};
    Object.keys(src).forEach((k) => {
      const n = Number(src[k]);
      if (!Number.isNaN(n) && n > 0) out[k] = n;
    });
    return out;
  }
  const out = {};
  Object.keys(raw).forEach((k) => {
    if (k === 'acl' || k === 'binds' || k === '__v') return;
    const n = Number(raw[k]);
    if (!Number.isNaN(n) && n > 0) out[k] = n;
  });
  return out;
}

function readAclLevel(acl, key) {
  if (key == null || key === '' || acl[key] == null) return null;
  const n = Number(acl[key]);
  return Number.isNaN(n) ? null : n;
}

const LAYOUT_CONTROLS = new Set([
  'UgoRow', 'UgoSection', 'UgoTabs', 'UgoCol', 'UgoTab',
  'Row', 'Section', 'Tabs', 'Col', 'Tab',
]);

function isLayoutControl(control) {
  return LAYOUT_CONTROLS.has(String(control || ''));
}

export default {
  methods: {
    fieldAcl(field) {
      if (!field) return 0;
      const acl = unpackAcl(this.acl);
      if (!acl || !Object.keys(acl).length) return 0;

      // 1) fullkey 精确命中
      const byFull = readAclLevel(acl, field.fullkey);
      if (byFull != null) return byFull;

      // 2) key 精确命中（即便已有 fullkey 也回退，兼容服务端 fullkey 与权限树不一致）
      const byKey = readAclLevel(acl, field.key);
      if (byKey != null) return byKey;

      // 3) 布局栏目常用 id 作为 ACL 键（PermissionSelect 对 layout 节点）
      if (field.id != null) {
        const byId = readAclLevel(acl, String(field.id));
        if (byId != null) return byId;
      }

      // 4) 路径后缀：acl 存 parent.child，字段只有 child
      if (field.key != null && field.key !== '') {
        const suffix = '.' + String(field.key);
        const hit = Object.keys(acl).find((k) =>
          k === String(field.key) || k.endsWith(suffix),
        );
        if (hit != null) {
          const n = readAclLevel(acl, hit);
          if (n != null) return n;
        }
      }
      return 0;
    },
    /**
     * 字段是否应在运行态隐藏：
     * - 自身 acl=2
     * - 或布局容器（栏目/行/页签）下所有子节点均不可见（避免空壳栏目）
     */
    isEffectivelyHidden(field) {
      if (!field) return true;
      if (this.fieldAcl(field) === 2) return true;
      const control = String(field.control || '');
      if (!isLayoutControl(control)) return false;
      const children = Array.isArray(field.fields) ? field.fields : [];
      if (!children.length) return false;
      return children.every((c) => this.isEffectivelyHidden(c));
    },
  },
};
